<template>
  <div>
    <PageAllow controller="ShopProfit" action="index" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="overflow-y-scroll fill-content-height">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherDatetimeRangeWithRadio
                v-model="options"
                type="datetime"
                show-radios
                :radios="datetimeRadios"
                removeIcon
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <!-- 导出/下载 按钮 -->
              <v-btn
                small
                color="print"
                dark
                class="ms-1"
                @click.stop="download()"
              >
                <v-icon x-small class="pe-1">fa-file-export</v-icon>
                {{ $t("ShopProfitAnalyze.Export.download") }}
              </v-btn>
              <v-btn
                small
                color="print"
                dark
                class="ms-1"
                @click.stop="exportExcel()"
              >
                <v-icon x-small class="pe-1">fa-file-excel</v-icon>
                {{ $t("ShopProfitAnalyze.Export.excel") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <!-- 客户 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherShops v-model="shopsSelected" />
                </v-col>
                <!-- 分组 -->
                <v-col cols="12" sm="6" md="4" v-if="settings && settings.report_hide_search_district_tree == 2">
                  <SearcherDistrictsWithDescendants
                    v-model="DistrictsSelected"
                    :label="
                      $t('shopDailyReports.shopDistricts', [$consts.shopName()])
                    "
                  />
                </v-col>
                <!-- 销售 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherAlliances v-model="alliancesSelected" />
                </v-col>
                <!-- 状态 -->
                <v-spacer />
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    v-model="options.status"
                    :label="$t('ShopProfitAnalyze.status.ObjectName')"
                    :items="$consts.shopProfitStatus"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <!-- 表格 -->
        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="shop_profit_analyze"
            :options.sync="options"
            :loading="loading"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            multi-sort
            class="elevation-1 px-4 pt-1"
            :footer-props="$t('$config.footer-props')"
          >
            <!-- 合计 -->
            <template v-slot:body.prepend>
              <tr class="d-none d-sm-table-row">
                <td colspan="2">
                  <span>{{ $t("TableSum") }}</span>
                </td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span
                    >{{ $t("Global.money")
                    }}{{ sale_total | formatMoney }}</span
                  >
                </td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span
                    >{{ $t("Global.money")
                    }}{{ cost_total | formatMoney }}</span
                  >
                </td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span
                    >{{ $t("Global.money")
                    }}{{ profit_total | formatMoney }}</span
                  >
                </td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span
                    >{{ profit_total_rate | formatTwoDot(true)
                    }}{{ $t("Global.rate") }}</span
                  >
                </td>
                <td></td>
              </tr>
              <!-- 小屏幕 -->
              <tr class="d-table-row d-sm-none">
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("TableSum") }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("materialProfitAnalyze.Fields.sale_total") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ $t("Global.money") }}{{ sale_total | formatMoney }}
                  </div>
                </td>

                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("materialProfitAnalyze.Fields.cost_total") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ $t("Global.money") }}{{ cost_total | formatMoney }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("ShopProfitAnalyze.Fields.profit_total") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ $t("Global.money") }}{{ profit_total | formatMoney }}
                  </div>
                </td>

                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("ShopProfitAnalyze.Fields.profit_total_rate") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ profit_total_rate | formatTwoDot(true)
                    }}{{ $t("Global.rate") }}
                  </div>
                </td>
              </tr>
            </template>

            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>

            <!-- 毛利率 -->
            <template v-slot:item.profit_rate="{ item }">
              {{ item.profit_rate | formatTwoDot(true) }}{{ $t("Global.rate") }}
            </template>
            <!-- 销售额 -->
            <template v-slot:item.sale_amount="{ item }">
              {{ $t("Global.money") }}{{ item.sale_amount | formatMoney }}
            </template>
            <!-- 毛利 -->
            <template v-slot:item.profit="{ item }">
              {{ $t("Global.money") }}{{ item.profit | formatMoney }}
            </template>
            <!-- 成本 -->
            <template v-slot:item.cost="{ item }">
              {{ $t("Global.money") }}{{ item.cost | formatMoney }}
            </template>

            <template v-slot:item.average_price="{ item }"
              >{{ $t("Global.money") }}
              {{ (item.price_sum / item.num_sum) | formatMoney }}
            </template>
            <!-- 明细 -->
            <template v-slot:item.actions="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    color="info"
                    class="px-2 me-2"
                    :href="'/#/material-profit?shop_id=' + item.id"
                    @click="changeMaterialOptions()"
                  >
                    <v-icon x-small class="pe-1">fa-align-left</v-icon>
                    {{ $t("MaterialDistribution.Fields.materialDeatil") }}
                  </v-btn>
                </template>
                <span>{{
                  $t("CRUD.viewInfo", [
                    $t("MaterialDistribution.Fields.materialDeatil"),
                  ])
                }}</span>
              </v-tooltip>
              <!-- 暂时隐藏门毛利明细 -->
              <v-tooltip top v-if="false">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    color="info"
                    class="px-2 me-2"
                    :href="'/#/shop-profit/detail/' + item.id"
                  >
                    <v-icon x-small class="pe-1">fa-align-left</v-icon>
                    {{
                      $t("MaterialDistribution.Fields.shopDetail", [
                        $consts.shopName(),
                      ])
                    }}
                  </v-btn>
                </template>
                <span>{{
                  $t("CRUD.viewInfo", [
                    $t("MaterialDistribution.Fields.shopDetail", [
                      $consts.shopName(),
                    ]),
                  ])
                }}</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    color="info"
                    class="px-2 me-2"
                    :href="'/#/order-profit?shop_id=' + item.id"
                    @click="changeOrderOptions()"
                  >
                    <v-icon x-small class="pe-1">fa-align-left</v-icon>
                    {{ $t("orderProfitAnalyze.title") }}
                  </v-btn>
                </template>
                <span>{{
                  $t("CRUD.viewInfo", [$t("orderProfitAnalyze.title")])
                }}</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import ShopProfitAnalyze from "@/api/shop_profit_analyze";
import SearcherAlliances from "@/components/plugins/SearcherAlliances";
import SearcherShops from "@/components/plugins/SearcherShops";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import consts from "@/consts";
import SearcherDistrictsWithDescendants from "@/components/plugins/SearcherDistrictsWithDescendants";

const defaultOptions = {
  datetimeRadioSelected: "created",
  created_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",

  actual_time_from: "",
  actual_time_to: "",

  alliance_business_ids: [],
  shop_ids: [],
  // district_id: "",
  status: [4, 5, 6],
  district_ids: [],
};

export default {
  data: () => ({
    shop_profit_analyze: [],
    paging: {},
    options: JSON.parse(JSON.stringify(defaultOptions)),
    loading: false,
    profit_total_rate: 0,
    profit_total: 0,
    cost_total: 0,
    sale_total: 0,
    alliancesSelected: null,
    shopsSelected: null,
    DistrictsSelected: [],
  }),
  components: {
    Breadcrumbs,
    SearcherDatetimeRangeWithRadio,
    PageAllow,
    SearcherAlliances,
    SearcherShops,
    SearcherStatus,
    SearcherDistrictsWithDescendants,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.profitAnalyze"),
        disabled: false,
        href: "/order-profit",
      },
      {
        text: i18n.t("Nav.shopProfit", [consts.shopName()]),
        disabled: true,
      },
    ],
    datetimeRadios: () => [
      {
        key: "created",
        text: i18n.t("ShopProfitAnalyze.Fields.created_date"),
      },
      {
        key: "actual",
        text: i18n.t("ShopProfitAnalyze.Fields.actual_time"),
      },
    ],
    headers() {
      var headers = [
        {
          text: i18n.t("ShopProfitAnalyze.Fields.shop_name"),
          align: "center",
          sortable: false,
          value: "shop_name",
        },
      ];
      return headers.concat([
        {
          text: i18n.t("ShopProfitAnalyze.Fields.shop_code"),
          align: "center",
          sortable: false,
          value: "shop_code",
        },
        // 销售额
        {
          text: i18n.t("ShopProfitAnalyze.Fields.sale_amount"),
          align: "end",
          sortable: false,
          value: "sale_amount",
        },
        // 成本
        {
          text: i18n.t("ShopProfitAnalyze.Fields.cost"),
          align: "end",
          sortable: false,
          value: "cost",
        },
        // 毛利
        {
          text: i18n.t("ShopProfitAnalyze.Fields.profit"),
          align: "end",
          sortable: false,
          value: "profit",
        },
        // 毛利率
        {
          text: i18n.t("ShopProfitAnalyze.Fields.profit_rate"),
          align: "end",
          sortable: false,
          value: "profit_rate",
        },
        // 操作
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        },
      ]);
    },
    ...mapState(["districtID", "settings"]),
  },

  mounted() {
    if (this.$route.query.dateType) {
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      if (this.$route.query.dateType == "today") {
        this.options.created_time_from =
          new Date(new Date().getTime()).toISOString().substr(0, 10) +
          " 00:00:00";
        this.options.created_time_to =
          new Date().toISOString().substr(0, 10) + " 23:59:59";
      }
      if (this.$route.query.dateType == "yesterday") {
        this.options.created_time_from =
          new Date(new Date().getTime() - 1 * 24 * 3600 * 1000)
            .toISOString()
            .substr(0, 10) + " 00:00:00";
        this.options.created_time_to =
          new Date(new Date().getTime() - 1 * 24 * 3600 * 1000)
            .toISOString()
            .substr(0, 10) + " 23:59:59";
      }
      sessionStorage.setItem(
        "shop_profit_analyze-options",
        JSON.stringify(this.options)
      );
    }
    this.$store.commit("districtID", 0);
    this.$store.commit(
      "searchDistrict",
      this.settings && this.settings.report_hide_search_district_tree == 1
        ? true
        : false
    );
    this.$commonUtils
      .loadOptions("shop_profit_analyze", [
        "alliancesSelected",
        "shopsSelected",
        "DistrictsSelected",
      ])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
          } else this.resetSearch();
          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "alliancesSelected":
                this.alliancesSelected = selected.value;
                break;
              case "shopsSelected":
                this.shopsSelected = selected.value;
                break;
              case "DistrictsSelected":
                this.DistrictsSelected = selected.value;
                break;
            }
          });
        }.bind(this)
      );
  },
  methods: {
    onSearch() {
      // 搜索
      this.options = Object.assign(this.options);
      this.getDistributionMAFromAPI();
    },
    resetSearch() {
      this.alliancesSelected = [];
      this.shopsSelected = [];
      this.DistrictsSelected = [];

      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },
    getDistributionMAFromAPI() {
      this.loading = true;
      var options = JSON.parse(JSON.stringify(this.options));
      if (
        this.settings &&
        this.settings.report_hide_search_district_tree == 1
      ) {
        options = Object.assign(options, {
          district_id: this.districtID,
        });
      }
      ShopProfitAnalyze.fetch(options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.shop_profit_analyze = response.data.shop_profit_analyze;
            this.profit_total_rate = response.data.profit_total_rate;
            this.profit_total = response.data.profit_total;
            this.sale_total = response.data.sale_total;
            this.cost_total = response.data.cost_total;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
          this.loading = false;
        }.bind(this)
      );
    },
    exportExcel() {
      var options = JSON.parse(JSON.stringify(this.options));
      if (
        this.settings &&
        this.settings.report_hide_search_district_tree == 1
      ) {
        options = Object.assign(options, {
          district_id: this.districtID,
        });
      }
      ShopProfitAnalyze.exports(options);
    },
    download() {
      var options = JSON.parse(JSON.stringify(this.options));
      if (
        this.settings &&
        this.settings.report_hide_search_district_tree == 1
      ) {
        options = Object.assign(options, {
          district_id: this.districtID,
        });
      }
      ShopProfitAnalyze.download(options);
    },
    changeMaterialOptions() {
      var options = {
        datetimeRadioSelected: this.options.datetimeRadioSelected,
        created_time_from: this.options.created_time_from,
        created_time_to: this.options.created_time_to,
        actual_time_from: this.options.actual_time_from,
        actual_time_to: this.options.actual_time_to,
        keyword: "",
        alliance_business_ids: [],
        shop_ids: [],
        district_ids: [],
        status: this.options.status,
      };
      sessionStorage.setItem(
        "material_profit_analyze-options",
        JSON.stringify(options)
      );
    },
    changeOrderOptions() {
      var options = {
        datetimeRadioSelected: this.options.datetimeRadioSelected,
        created_time_from: this.options.created_time_from,
        created_time_to: this.options.created_time_to,
        actual_time_from: this.options.actual_time_from,
        actual_time_to: this.options.actual_time_to,

        alliance_business_ids: [],
        shop_ids: [],
        district_ids: [],
        status: [4, 5, 6],
      };
      sessionStorage.setItem(
        "order_profit_analyze-options",
        JSON.stringify(options)
      );
    },
  },
  watch: {
    districtID: {
      handler() {
        this.getDistributionMAFromAPI();
      },
    },
    options: {
      deep: true,
      handler() {
        this.getDistributionMAFromAPI();
        sessionStorage.setItem(
          "shop_profit_analyze-options",
          JSON.stringify(this.options)
        );
      },
    },
    // 销售
    alliancesSelected: {
      handler() {
        this.options.alliance_business_ids = this.alliancesSelected
          ? this.alliancesSelected.map((e) => {
              return e.id;
            })
          : "";
        sessionStorage.setItem(
          "shop_profit_analyze-alliancesSelected",
          JSON.stringify(this.alliancesSelected)
        );
      },
    },
    // 门店
    shopsSelected: {
      handler() {
        this.options.shop_ids = this.shopsSelected
          ? this.shopsSelected.map((e) => {
              return e.id;
            })
          : "";
        sessionStorage.setItem(
          "shop_profit_analyze-shopsSelected",
          JSON.stringify(this.shopsSelected)
        );
      },
    },
    DistrictsSelected: {
      handler() {
        if (this.settings &&
          this.settings.report_hide_search_district_tree == 2)
        { 
          this.options.district_ids = this.DistrictsSelected
            ? this.DistrictsSelected.map((e) => {
              return e.id;
            })
            : [];
          sessionStorage.setItem(
            "shop_profit_analyze-DistrictsSelected",
            JSON.stringify(this.DistrictsSelected)
          );
        }
      },
    },
    settings: {
      handler() {
        this.$store.commit(
          "searchDistrict",
          this.settings && this.settings.report_hide_search_district_tree == 1
            ? true
            : false
        );
      },
    },
  },
};
</script>

<style>
</style>